import { allpeepNoPayloadEndpoint } from './helpers.js';
export const location = (rawClient) => ({
    geocode: allpeepNoPayloadEndpoint(rawClient, '/location/geocode'),
});
